// Hindi translations for seeded FAQs.
// Keyed by English question (case-insensitive substring match) so it works
// even if the DB contents evolve slightly.
export const FAQ_HI = {
  "is this really 100% pure gir gaumata milk": {
    question: "क्या यह वास्तव में 100% शुद्ध गीर गौमाता का दूध है?",
    answer:
      "बिल्कुल! हमारी सभी गायें प्रमाणित गीर नस्ल की हैं, जिन्हें प्राकृतिक चारा खिलाया जाता है। हम कोई हार्मोन, एंटीबायोटिक या मिलावट का उपयोग नहीं करते। हर बैच की शुद्धता की जाँच की जाती है।",
  },
  "what time do you deliver": {
    question: "आप किस समय डिलीवर करते हैं?",
    answer:
      "हम रोज़ाना सुबह 5:30 से 6:30 बजे के बीच डिलीवर करते हैं, ताकि आपके नाश्ते से पहले ताज़ा दूध पहुँच जाए।",
  },
  "can i pause or cancel": {
    question: "क्या मैं कभी भी रोक या रद्द कर सकता हूँ?",
    answer:
      "हाँ! बिना कोई प्रश्न पूछे कभी भी रोकें, फिर से शुरू करें या रद्द करें। कोई लॉक-इन नहीं, कोई शुल्क नहीं।",
  },
  "which areas do you deliver to": {
    question: "आप कौन-कौन से क्षेत्रों में डिलीवर करते हैं?",
    answer:
      "हम पूरी नवी मुंबई में डिलीवरी करते हैं:\n\n" +
      "✅ अभी उपलब्ध: वाशी · सानपाडा · तुर्भे · जुईनगर · नेरुल · सीवूड्स · सीबीडी बेलापुर · घनसोली · कोपरखैराणे · रबाले\n\n" +
      "🔜 जल्द शुरू: ऐरोली · कामोठे · कालंबोली · पनवेल · तलोजा\n\n" +
      "🚀 भविष्य में विस्तार: ठाणे · दादर · बोरीवली · कांदिवली · मालाड · गोरेगांव",
  },
  "how do i pay": {
    question: "मैं भुगतान कैसे करूँ?",
    answer:
      "आप व्हाट्सऐप पर बैंक ट्रांसफ़र, UPI या कैश-ऑन-डिलीवरी से भुगतान कर सकते हैं। बिलिंग पारदर्शी है — कोई छिपा शुल्क नहीं।",
  },
  "what is a2 milk": {
    question: "A2 दूध क्या है?",
    answer:
      "A2 दूध देसी गायों (जैसे गीर) से आता है जिनमें केवल A2 बीटा-कैसिइन प्रोटीन होता है। यह हाइब्रिड गायों के A1 दूध की तुलना में पचाने में बेहतर और स्वास्थ्यवर्धक माना जाता है।",
  },
  "how is the milk packed": {
    question: "दूध कैसे पैक किया जाता है?",
    answer:
      "हर दिन सुबह हम दूध को फ़ूड-ग्रेड सील्ड पाउच में पैक करते हैं — बोतलें नहीं, क्योंकि ये ताज़गी बेहतर बनाए रखते हैं।",
  },
  "do you sell ghee": {
    question: "क्या आप घी भी बेचते हैं?",
    answer:
      "हाँ! हमारा पारंपरिक विधि से बना A2 देसी घी ₹2,100/किलो में उपलब्ध है। व्हाट्सऐप पर ऑर्डर करें।",
  },
  "how do i subscribe": {
    question: "मैं सब्सक्राइब कैसे करूँ?",
    answer:
      "वेबसाइट से कोई भी प्लान चुनें और ऑनलाइन चेकआउट करें, या +91 98199 33676 पर व्हाट्सऐप करें — हमारी टीम एक मिनट में सब सेट कर देगी।",
  },
  "what is the minimum subscription period": {
    question: "न्यूनतम सब्सक्रिप्शन अवधि क्या है?",
    answer:
      "कोई नहीं! आप ₹84 में 1 दिन का ट्रायल ले सकते हैं — सिर्फ ₹84 में 1 लीटर। मासिक योजनाएँ ₹100/लीटर पर बेहतर मूल्य देती हैं।",
  },
  "how is gir milk different from amul or packet milk": {
    // Retained only to prevent lookup breakage if a stale DB still has this question.
    // Backend no longer seeds this FAQ as of v10.
    question: "गीर दूध अमूल या पैकेट दूध से कैसे अलग है?",
    answer:
      "अमूल और अधिकांश पैकेट दूध HF/जर्सी (A1 प्रोटीन) गायों का होता है जिसमें पानी और परिरक्षक मिलाए जाते हैं। हमारा गीर दूध A2 बीटा-कैसिइन होता है — पचाने में आसान, पोषक तत्वों से भरपूर, और मिलावट रहित।",
  },
  "do you offer corporate or bulk orders": {
    question: "क्या आप कॉर्पोरेट या बल्क ऑर्डर लेते हैं?",
    answer:
      "हाँ! हमारा कॉर्पोरेट प्लान (5 लीटर/दिन × 30 दिन) — डेडिकेटेड अकाउंट मैनेजर, GST इनवॉइस, कस्टम बिलिंग और ऑफिस/प्रीमियम गिफ्टिंग के लिए प्राथमिकता डिलीवरी के साथ।",
  },
};

export function matchFaqHi(question) {
  if (!question) return null;
  const clean = (s) => (s || "").toLowerCase().replace(/[^a-z0-9 ]/g, "").replace(/\s+/g, " ").trim();
  const key = clean(question);
  for (const k of Object.keys(FAQ_HI)) {
    if (key.includes(clean(k))) return FAQ_HI[k];
  }
  return null;
}
